import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const CustomMap = ({ geoJsonData }: { geoJsonData: any }) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		window.addEventListener('resize', handleResize);

		const initialView: L.LatLngTuple = isMobile ? [-7, 110] : [-7, 109];
		const initialZoom: number = isMobile ? 5 : 7.5;

		const map = L.map('map').setView(initialView, initialZoom);

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors'
		}).addTo(map);

		if (geoJsonData) {
			L.geoJSON(geoJsonData, {
				style: (feature: any) => ({
					color: 'blue',
					weight: 2,
					fillOpacity: 0.5
				}),
				onEachFeature: (feature: any, layer: any) => {
					if (feature.properties && feature.properties.name) {
						layer.bindPopup(`<strong>${feature.properties.name}</strong>`);
					}
				}
			}).addTo(map);
		}

		return () => {
			map.remove();
		};
	}, [geoJsonData]);

	return <div id="map" className="coverage-map"></div>;
};

export default CustomMap;
